var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "welcome",
      style: _vm.$store.getters["customizer/getWelcomeStyles"]
    },
    [
      _c("h2", { staticClass: "welcome__salutation" }, [
        _c("span", { staticClass: "welcome__text", style: _vm.getTextStyles }, [
          _vm._v("\n      " + _vm._s(_vm.getSalutation) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c("h2", { staticClass: "welcome__name" }, [
        _c("span", { staticClass: "welcome__text", style: _vm.getTextStyles }, [
          _vm._v("\n      " + _vm._s(_vm.getName) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "welcome__home-button", style: _vm.getTextStyles },
        [
          _c("RegistrationButton", { attrs: { "is-active": true } }, [
            _vm._v("\n      " + _vm._s(_vm.getBack) + "\n    ")
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f5af56e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f5af56e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Welcome.vue
// module id = null
// module chunks = 